export const rsvpAnswerTypes = ['string', 'boolean', 'list'] as const;

export const enum RsvpAnswerType {
  Boolean = 'boolean',
  List = 'list',
  String = 'string',
  // not supported in RSVP v1
  // Conditional = 'conditional',
}
